import { createFileRoute } from '@tanstack/react-router'
import { CustomToolsManager } from '../../../../components/CustomToolsManager'

export const Route = createFileRoute('/platform/desa/$desaId/custom-tools')({
  component: () => {
    const { desaId } = Route.useParams()
    return <CustomToolsManager desaId={desaId} />
  },
})
